import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { getDeepLinkId } from '@/app/components/search/Janus/utils';
import type { DealCard } from '@/app/components/search/utils/buildDealCards/dealCardTypes.ts';
import { registerEvents } from '@/app/components/search/Analytics/utils';
import logDevOnly from '../utils/logDevOnly';

type AnalyticsResultClicked = {
  searchParams: SearchParams;
  dealCard: DealCard;
  clickId: string;
  ctaName: string;
};
const analyticsResultClicked = ({ searchParams, dealCard, clickId, ctaName }: AnalyticsResultClicked) => {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  if (!(window as any).platformData?.filter((x: any) => x.event === 'gaObjectReady')[0]) return;

  const searchId = searchParams[URLParameters.SEARCH_ID];
  const productId = dealCard?.product?.accommodation?.hotelId ? `${dealCard?.product?.accommodation?.hotelId}` : '';
  const deeplinkId = getDeepLinkId({ searchId, productId, ctaName });

  const data = {
    event: 'userInteraction',
    results: {
      deeplinkId: `${deeplinkId}_${clickId}`,
    },
    search: {
      searchId,
    },
    user: {
      interaction: {
        category: 'results_list',
        action: ctaName,
        label: 'card',
        n: 0,
      },
    },
  };

  logDevOnly({ data, title: 'ANALYTICS RESULT CLICKED' });

  registerEvents(data);
};

export default analyticsResultClicked;
